module.exports = __webpack_public_path__ + "static/media/ios-medkit.4e900541.svg";